 
import { useRef } from "react";
import { ActionHandlerProvider } from "../Components/ActionHandlerContext";

import { FormInstance } from "antd";
import InterfaceComponent from "./Masters/InterfaceComponent";

export default function DocViewInterface() {
  const formRef = useRef<FormInstance>(null);
  
  return (
      <ActionHandlerProvider>
       <InterfaceComponent
          InterfaceName={"Documents"}
          DashboardName={""}
          actionType={"DynamicFormActionCreate"}
          RId={null}
          Mode={"Create"}
          
          ref={formRef}
        />
        
      </ActionHandlerProvider>
  );
}
